var _circle, _circle2, _g, _circle3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 133,
    viewBox: "0 0 127 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 44.5,
    transform: "matrix(-0.881064 0.472996 0.472996 0.881064 82.0671 7.89062)",
    stroke: "#F25041",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 32,
    r: 31.5,
    fill: "url(#paint0_linear_453_3668)",
    stroke: "url(#paint1_linear_453_3668)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_3668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5097 23.5186L94.5491 47.9378L104.589 23.5186H106.06L95.2662 49.7871H93.7943L83 23.5186H84.5097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.24 15.8944L100.54 14V15.2333H84.7681V16.555H100.54V17.7887L104.24 15.8944Z",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 101,
    r: 31.5,
    fill: "url(#paint2_linear_453_3668)",
    stroke: "url(#paint3_linear_453_3668)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip1_453_3668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2973 108.5C37.7846 108.499 37.2786 108.383 36.8162 108.162C36.3538 107.941 35.9467 107.619 35.6244 107.22C35.3021 106.821 35.0728 106.356 34.9532 105.857C34.8336 105.359 34.8268 104.84 34.9331 104.338C35.106 103.551 35.5451 102.848 36.1764 102.347C36.8076 101.846 37.5923 101.578 38.3981 101.588H40.5889C40.7105 101.588 40.8271 101.54 40.913 101.454C40.999 101.368 41.0473 101.252 41.0473 101.13V99.0675C41.0449 98.4605 40.8026 97.879 40.3734 97.4497C39.9441 97.0205 39.3626 96.7782 38.7556 96.7758H25.9223C25.7399 96.7758 25.5651 96.7034 25.4361 96.5745C25.3072 96.4455 25.2348 96.2707 25.2348 96.0883C25.2348 95.906 25.3072 95.7311 25.4361 95.6022C25.5651 95.4733 25.7399 95.4008 25.9223 95.4008H38.0681C38.1289 95.4008 38.1872 95.3767 38.2302 95.3337C38.2731 95.2907 38.2973 95.2324 38.2973 95.1717V94.9792C38.2973 93.7142 36.8581 92.6875 35.0889 92.6875H25.0056C24.5843 92.6875 24.1671 92.7705 23.7778 92.9317C23.3886 93.093 23.0349 93.3293 22.737 93.6272C22.1353 94.2289 21.7973 95.0449 21.7973 95.8958V110.104C21.7973 110.955 22.1353 111.771 22.737 112.373C23.0349 112.671 23.3886 112.907 23.7778 113.068C24.1671 113.23 24.5843 113.312 25.0056 113.312H38.7556C39.0566 113.312 39.3545 113.253 39.6326 113.138C39.9106 113.023 40.1633 112.854 40.3761 112.641C40.5889 112.428 40.7577 112.176 40.8728 111.898C40.988 111.62 41.0473 111.322 41.0473 111.021V108.729C41.0473 108.668 41.0231 108.61 40.9802 108.567C40.9372 108.524 40.8789 108.5 40.8181 108.5H38.2973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.047 103H38.297C37.75 103 37.2254 103.217 36.8386 103.604C36.4518 103.991 36.2345 104.515 36.2345 105.062C36.2345 105.61 36.4518 106.134 36.8386 106.521C37.2254 106.908 37.75 107.125 38.297 107.125H41.047C41.3706 107.07 41.6641 106.902 41.8742 106.649C42.0844 106.397 42.1974 106.078 42.1928 105.75V104.375C42.1974 104.047 42.0844 103.728 41.8742 103.476C41.6641 103.223 41.3706 103.055 41.047 103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_453_3668",
    x1: 95,
    y1: 43.978,
    x2: 95,
    y2: 73.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_453_3668",
    x1: 95,
    y1: 0,
    x2: 95,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_453_3668",
    x1: 32,
    y1: 58,
    x2: 32,
    y2: 142.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_453_3668",
    x1: 32,
    y1: 69,
    x2: 32,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_3668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.086,
    height: 35.8162,
    fill: "white",
    transform: "translate(83 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_453_3668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(21 92)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2074434273557c74910fc8a6482b3ec7.svg";
export { ForwardRef as ReactComponent };